export default __webpack_public_path__ + "static/media/omnes_medium-webfont.ce3b45d5.eot";